import { apply, celebrate, burst, take, toast } from '../core/effects';
import { S } from '../core/game';
import type { Person } from '../core/state';
import { m } from '../i18n';
import { playBirthdayTune } from '../audio/sfx';
import { say as speak, VOICES } from '../audio/speech';
import { say } from '../ui/dialog';

/** Birthday parties: each one needs a cake and can be celebrated once per save. */
export function openPartyMenu(): void {
  const t = m().party;
  const s = S();
  const date = (p: Person) => t.date(s.birthdays[p].m, s.birthdays[p].d);
  const entry = (p: Person, label: string) => ({
    text: `${s.forever[`party.${p}`] ? '✅ ' : ''}${label}`,
    disabled: !!s.forever[`party.${p}`],
    run: () => party(p),
  });
  say({
    who: t.title,
    icon: '🎂',
    text: `${t.text}\n🍰×${s.bag.cake}`,
    choices: [entry('me', t.me(date('me'))), entry('mom', t.mom(date('mom'))), entry('dad', t.dad(date('dad'))), entry('emma', t.emma(date('emma')))],
  });
}

function party(p: Person): void {
  const s = S();
  const t = m().party;
  if (s.forever[`party.${p}`]) return toast(t.done);
  if (!take('cake')) return toast(t.needCake);
  s.forever[`party.${p}`] = true;
  playBirthdayTune();
  burst('sparkle', 20);

  if (p === 'me') {
    window.setTimeout(() => speak(m().party.meVoice, VOICES.mom), 1200);
    say({
      who: t.meTitle,
      icon: '🎂',
      text: t.meText,
      choices: [
        {
          text: t.meWish,
          run: () => {
            celebrate(true);
            apply({ stars: 30, coins: 100, mood: 100 });
            say({ who: m().party.meTitle, icon: '🕯️', text: m().party.meBlow, choices: [{ text: m().party.meThanks }] });
          },
        },
      ],
    });
    return;
  }

  const conf = {
    mom: { title: t.momTitle, text: t.momText, act: t.momAct, voice: t.momVoice, done: t.momDone, v: VOICES.mom, love: { mom: 100 }, stars: 20 },
    dad: { title: t.dadTitle, text: t.dadText, act: t.dadAct, voice: t.dadVoice, done: t.dadDone, v: VOICES.dad, love: { dad: 100 }, stars: 20 },
    emma: { title: t.emmaTitle, text: t.emmaText, act: t.emmaAct, voice: t.emmaVoice, done: t.emmaDone, v: VOICES.emma, love: { emma: 100 }, stars: 15 },
  }[p];
  window.setTimeout(() => speak(conf.voice, conf.v), 1500);
  say({
    who: conf.title,
    icon: '🎉',
    text: conf.text,
    choices: [
      {
        text: conf.act,
        run: () => {
          celebrate(true);
          burst('heart', 10);
          apply({ stars: conf.stars, mood: 100, love: conf.love });
          toast(conf.done);
        },
      },
    ],
  });
}
